import { InsightsPageTemplate } from "@/components/templates/InsightsPageTemplate";
import { aiAgentsCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiAgentsCluster.insightPages.find(p => p.slug === "ai-agents-vs-chatbots")!;
const relatedMoney = getRelatedMoneyPages("ai-agents").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-agents").map(p => ({ title: p.title, slug: p.slug }));

export default function AIAgentsVsChatbotsPage() {
  return (
    <InsightsPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
